import React from 'react';

export const TextInput = ({ formName, defaultValue, onChange }) => {
  return (
    <input
      className="input input-sm"
      name={formName}
      defaultValue={defaultValue}
      placeholder="Domyślna wartość"
      onChange={(evet) => onChange(event.target.value)}
    ></input>
  );
};
